module.exports = __webpack_public_path__ + "img/GoS_Logo-White.21cd98b5.png";